import { render, staticRenderFns } from "./AppSidebarLink.vue?vue&type=template&id=41379353"
import script from "./AppSidebarLink.vue?vue&type=script&lang=js"
export * from "./AppSidebarLink.vue?vue&type=script&lang=js"
import style0 from "./AppSidebarLink.vue?vue&type=style&index=0&id=41379353&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports